import { render, staticRenderFns } from "./BbppProductServicesS.vue?vue&type=template&id=783fb047"
import script from "./BbppProductServicesS.vue?vue&type=script&lang=js"
export * from "./BbppProductServicesS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports